<div class="tw-relative tw-flex-grow tw-flex tw-bg-gray-300 tw-text-white tw-text-xl tw-font-semibold tw-justify-center tw-items-center tw-rounded-lg tw-p-2 tw-h-14"
    [ngStyle]="{ 'width.%': width, 'background-color': '#' + quota?.contentCull?.color}">
  <div class="tw-absolute tw-w-full tw-text-ellipsis tw-overflow-hidden tw-pl-4" [title]="(quota.name ? quota.name : ('lang.contentShare.quota.defaultName' | translate)) + ' - ' + quota.share + '%'">
    {{ (quota.name ? quota.name : ('lang.contentShare.quota.defaultName' | translate)) + ' - ' + quota.share + '%' }}
  </div>
</div>
